module.exports = __webpack_public_path__ + "img/201609-1.76f6ebaa.jpg";